import Component from '../core/Component'
import { toggleClass } from '../utils/dom'

export default class Like extends Component {
    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        event.preventDefault()
        toggleClass(this.element, 'is-active')
    }
}